import React from 'react'
import type { ProfileData } from '../types/ProfileData'
import Container from './Container'

const Button: React.FC<{
    label: string;
    onClick: () => void;
    disabled?: boolean;
}> = ({ label, onClick, disabled }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className="flex gap-4 md:gap-2 lg:gap-2.5 flex-row items-center justify-center 
            w-full max-w-[250px] md:w-[100px] lg:w-[120px] xl:w-[130px] 2xl:w-[130px]
            h-8 md:h-8 lg:h-10 xl:h-10 2xl:h-12
            px-4 md:px-1
            bg-white rounded-sm md:text-[9px] lg:text-[10px] border cursor-pointer disabled:opacity-60"
        >
            <p className="text-center font-ubuntu  text-[14px] md:text-[14px] lg:text-[14px] xl:text-[14px] 2xl:text-[14px] text-slate-900">{label}</p>
        </button>
    )
}

const ProfileHeader: React.FC<{
    profileData: ProfileData
}> = ({ profileData }) => {
    const { name, username, profile_picture } = profileData;
    console.log('username', username);
    const providerEndpoint =
        (typeof import.meta !== 'undefined' && (import.meta as any)?.env?.PROVIDER_ENDPOINT) ||
        (typeof process !== 'undefined' && (process as any)?.env?.PROVIDER_ENDPOINT) ||
        'https://employability.ai';

    const handleViewProfile = () => {
        if (!username || !providerEndpoint) return;
        window.open(`${providerEndpoint}/profile/${username}`, '_blank', 'noopener,noreferrer');
    };

    return (
        <Container className='flex flex-row justify-between items-center px-8! py-6!'>
            <div className='flex flex-row items-center gap-3.5'>
                {
                    profile_picture ? (
                        <img src={profile_picture} alt={name} className='w-10 h-10 rounded-full object-cover' />
                    ) : (
                        <div className='w-10 h-10 rounded-full bg-[#004D41] flex items-center justify-center p-0'>
                            <span className='text-[20px] font-medium text-white'>{name.charAt(0)}</span>
                        </div>
                    )
                }
                <p className='text font-medium'>{name}</p>
            </div>
            <div>
                <Button label="View Profile" onClick={handleViewProfile} disabled={!username} />
            </div>
        </Container>
    )
}

export default ProfileHeader